import { styled } from '@ori-ui/mui';

export const CenteredRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'white',
});

export const CopyrightRoot = styled(CenteredRoot)({
  height: '40px',
});

export const LinksRoot = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'grid',
  rowGap: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(150px, 1fr)',
    justifyContent: 'center',
    justifyItems: 'center',
    columnGap: theme.spacing(3),
  },
}));

export const SubscribeBannerRoot = styled(CenteredRoot)({
  height: 70,
});
